import { BsGlobe } from "react-icons/bs";
import { MdOutlineMail } from "react-icons/md";
import meroshare from "../../assets/navbar/meroshare.png";
import connectips from "../../assets/navbar/connectips.png";
import banksmart from "../../assets/logo512.png";
import "./loginDropdown.scss";

const LoginDropdown = () => {
  return (
    <div className="loginDropCompContainer">
      <div className="item">
        <a
          href="https://mycard.sct.com.np/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={banksmart} alt="" aria-hidden="true" />
          <p>
            My Card
            <span className="a11y-sr-only"> (opens in new window)</span>
          </p>
        </a>
        <div className="underline"></div>
        <a
          href="https://banksmartxp.icfcbank.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={banksmart} alt="" aria-hidden="true" />
          <p>
            Bank Smart XP
            <span className="a11y-sr-only"> (opens in new window)</span>
          </p>
        </a>
        <div className="underline"></div>
        <a
          href="https://www.eicfc.com.np/login.asp"
          target="_blank"
          rel="noopener noreferrer"
        >
          <BsGlobe size={20} aria-hidden="true" focusable="false" />
          <p>
            E-Banking
            <span className="a11y-sr-only"> (opens in new window)</span>
          </p>
        </a>
        <div className="underline"></div>

        <a
          href="https://mail.icfcbank.com/owa/auth/logon.aspx?replaceCurrent=1&url=https%3a%2f%2fmail.icfcbank.com%2fowa%2f"
          target="_blank"
          rel="noopener noreferrer"
        >
          <MdOutlineMail size={22} aria-hidden="true" focusable="false" />
          <p>
            Email Login
            <span className="a11y-sr-only"> (opens in new window)</span>
          </p>
        </a>
        <div className="underline"></div>

        <a
          href="https://meroshare.cdsc.com.np/#/login"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={meroshare} alt="" aria-hidden="true" />
          <p>
            Mero Share
            <span className="a11y-sr-only"> (opens in new window)</span>
          </p>
        </a>
        <div className="underline"></div>

        <a
          href="https://www.connectips.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={connectips} alt="" aria-hidden="true" />
          <p>
            Connect IPS
            <span className="a11y-sr-only"> (opens in new window)</span>
          </p>
        </a>
      </div>
    </div>
  );
};

export default LoginDropdown;
